import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBehavioralIndicatorGroup} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchBehavioralIndicatorsThunk: any = createAsyncThunk<IBehavioralIndicatorGroup[]>(
  `${prefix} fetchBehavioralIndicators`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getBehavioralIndicators();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch behavioral indicators. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
